import React, { useCallback } from "react";
import { useNavigate } from "react-router-dom-v5-compat";

import Footer from "components/projects/Footer";
import { useAnswerContext } from "contexts/answerContext";
import routes from "utils/routes";

const SummaryFooter = (props) => {
  const navigate = useNavigate();
  const { record: project } = useAnswerContext();
  const onNav = useCallback(
    () => navigate(routes.projectHandoff(project.id)),
    [navigate, project.id],
  );
  return (
    <Footer
      {...props}
      nextTextKey="guides.footer.done"
      backTextKey="guides.footer.exit"
      onBack={onNav}
      onNext={onNav}
    />
  );
};
export default SummaryFooter;
